export const isWebsiteSwitcherOpenSelector = (state) => state.get('ui').get('menu').get('websiteSwitcher');

export const isUserNavigationOpenSelector = (state) => state.get('ui').get('menu').get('userNavigation');
